import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import cx from 'classnames';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useMutation } from '@apollo/client';

import Link from '../../Link/Link';
import CustomPagination from '../../CustomPagination/CustomPagination';

import messages from '../../../locale/messages';
import getCurrentPage from '../../../helpers/getCurrentPage';
import { deleteOnBoardingContent, getAllOnBoardingContent, updateOnBoardingContent } from '../../../lib/graphql';
import showToaster from '../../../helpers/toastrMessgaes/showToaster';

import { CommonAdminEditIcon, CommonAdminTrashIcon } from '../../Common/Assets/SVGIcon/CommonSvgIcon';

import bt from '../../../components/commonStyle.css';
import s from './ManageProviderOnBoardingScreens.css';

const ManageProviderOnBoardingScreens = (props) => {

    const {
        data,
        refetch,
        setCurrentPage,
        currentPage
    } = props;

    const { formatMessage } = useIntl();
    const dispatch = useDispatch();

    const paginationData = (page) => {
        setCurrentPage(page);
        refetch({ currentPage: page });
    };

    const [deleteContent] = useMutation(deleteOnBoardingContent);
    const [updateContentStatus] = useMutation(updateOnBoardingContent);

    const handleDelete = async (id, page) => {
        try {
            const newPage = await getCurrentPage({
                results: data?.results,
                page
            });
            const { data: response } = await deleteContent({
                variables: { id }
            });
            if (response?.deleteOnBoardingContent?.status == '200') {
                showToaster({ messageId: 'deleteOnBoardingContent', toasterType: 'success' })
                setCurrentPage(page);
                refetch({ currentPage: newPage });
            } else {
                showToaster({ messageId: response?.deleteOnBoardingContent?.errorMessage, toasterType: 'error' })
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleUpdate = async ({ id, status, page }) => {
        try {
            const { data: response } = await updateContentStatus({
                variables: { id, status }
            });
            if (response?.updateOnBoardingContent?.status == '200') {
                showToaster({ messageId: 'updateOnBoardingContent', toasterType: 'success' })
                refetch({ currentPage: page });
            }
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div>
            <div className={cx(bt.displayFlex, bt.justifyContentEnd, s.btnSection)}>
                <Link to={'/siteadmin/provider-onboarding-screens/add'} className={cx(bt.btnPrimary, bt.displayInlineBlock)}>
                    <FormattedMessage {...messages.add} />
                </Link>
            </div>
            <div className={cx('tableOuterContainer', bt.spaceTop4)}>
                <Table className="tableContainer">
                    <thead>
                        <tr>
                            <th scope="col"><FormattedMessage {...messages.id} /></th>
                            <th scope="col"><FormattedMessage {...messages.pageTitle} /></th>
                            <th scope="col"><FormattedMessage {...messages.action} /></th>
                            <th scope="col"><FormattedMessage {...messages.deleteAction} /></th>
                            <th scope="col"><FormattedMessage {...messages.status} /></th>
                        </tr>
                    </thead>
                    <tbody>
                        {data?.results?.length > 0 ? (
                            data.results.map((item, index) => (
                                <tr key={index}>
                                    <td data-label={formatMessage(messages.id)}>{item?.id}</td>
                                    <td data-label={formatMessage(messages.pageTitle)}>{item?.pageTitle}</td>
                                    <td data-label={formatMessage(messages.action)}>
                                        <div>
                                            <Link to={'/siteadmin/provider-onboarding-screens/edit/' + item.id} className={s.noLink}>
                                                <CommonAdminEditIcon className={cx(s.editIcon, 'editIconRTL')} />
                                                <span className={cx(s.vtrMiddle)}>
                                                    <FormattedMessage {...messages.editAction} />
                                                </span>
                                            </Link>
                                        </div>
                                    </td>
                                    <td data-label={formatMessage(messages.deleteAction)}>
                                        <div>
                                            <Button onClick={() => handleDelete(item.id, currentPage)} className={s.iconBtn}>
                                                <CommonAdminTrashIcon className={cx(s.editIcon, 'editIconRTL')} />
                                                <span className={s.vtrMiddle}>
                                                    <FormattedMessage {...messages.deleteAction} />
                                                </span>
                                            </Button>
                                        </div>
                                    </td>
                                    <td data-label={formatMessage(messages.status)}>
                                        <div>
                                            {
                                                <Link className={s.noLink} noLink
                                                    onClick={() => handleUpdate({ id: item.id, status: item.status == 'disabled' ? 'enabled' : 'disabled', page: currentPage })}>
                                                    {formatMessage(messages[item.status == 'disabled' ? 'Enable' : 'Disable'])}
                                                </Link>
                                            }
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="12" className={'tableNoRecordCel'}>
                                    <FormattedMessage {...messages.noResult} />
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
            {data?.results?.length > 0 && (
                <div className={cx(bt.space5, bt.spaceTop5)}>
                    <CustomPagination
                        total={data?.count}
                        currentPage={currentPage}
                        defaultCurrent={1}
                        defaultPageSize={10}
                        change={paginationData}
                        paginationLabel={formatMessage(messages.paginationrecords)}
                    />
                </div>
            )}
        </div>
    );
};

export default withStyles(bt, s)(ManageProviderOnBoardingScreens);